module.exports = __webpack_public_path__ + "img/16.fa3755a5.png";